// removed by extract-text-webpack-plugin
module.exports = {"Menu":"l3EzYcCDs9G2GMJe5Pfin"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Menu/Menu.css
// module id = 659
// module chunks = 0